import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
import Breadcrumbs from '../components/Breadcrumbs';

// Utils
import { countData } from '../../utils/SamuiUtils';

function BorrowWithdrawal() {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    const fetchCounts = async () => {
      const tables = ['WH_ITEM_Onhand', 'WHDoc_H'];
      const countsData = {};

      for (const table of tables) {
        countsData[table] = await countData(table, '');
      }

      setCounts(countsData);
    };

    fetchCounts();
  }, []);

  const renderCard = (category, icon, table, additionalInfo, path) => (
    <div className="col-sm-6 col-md-2" style={{ cursor: 'pointer' }} onClick={() => window.location.replace(path)}>
      <div className="card card-stats card-round">
        <div className="card-body d-flex flex-column align-items-center">
          <div className="col-icon mb-3">
            <div className="icon-big text-center icon-secondary bubble-shadow-small" style={{ backgroundColor: 'orange' }}>
              <i className={icon} />
            </div>
          </div>
          <div className="col col-stats text-center">
            <div className="numbers">
              <p className="card-category">{category}</p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                <li style={{ color: 'orange' }}>
                  {counts[table] !== undefined ? `${counts[table]} รายการ` : 'Loading...'}
                </li>
              </ul>
            </div>
          </div>
          {/* <div className="col col-stats text-center">
            <div className="row">
              {additionalInfo.map((item, index) => (
                <div key={index} className="col-4" style={{ color: 'gray', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="far fa-clock" aria-hidden="true" style={{ fontSize: '15px', marginRight: '5px' }}></i>
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );

  return (
    <div className="BorrowWithdrawal">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              <div className="page-header d-flex justify-content-between align-items-center">
                <Breadcrumbs page={"ใบยืม-ใบเบิก"} items={[
                  { name: 'ใบยืม-ใบเบิก', url: '/borrow-withdrawal' },
                ]} />
              </div>
              <div className="row">
                {renderCard('ใบเบิกสินค้า', 'fas fa-archive', 'WHDoc_H', [5, 0, 0], '/bill-of-lading')}
                {renderCard('ใบยืมสินค้า', 'fas fa-th-large', 'WHDoc_H', [5, 0, 0], '/icebox')}
                {renderCard('ใบเบิกช่าง', 'fas fa-wrench', 'WHDoc_H', [5, 0, 0], '/technical-equip-form')}
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default BorrowWithdrawal;